//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import repeatDialog from './repeatDialog';
import { dealtScheduleAddApi, dealtScheduleEditApi } from '@/api/user';
import { clientFollowEditApi } from '@/api/enterprise';
export default {
  name: 'Index',
  components: {
    repeatDialog: repeatDialog
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      rules: {
        time: '',
        marks: '',
        content: '',
        repeat: -1
      },
      rule: {
        content: [{
          required: true,
          message: this.$t('calendar.placeholder12'),
          trigger: 'blur'
        }],
        time: [{
          required: true,
          message: this.$t('calendar.placeholder13'),
          trigger: 'change'
        }]
      },
      options: [{
        value: -1,
        label: this.$t('calendar.norepetition')
      }, {
        value: 0,
        label: this.$t('calendar.repeatbyday')
      }, {
        value: 1,
        label: this.$t('calendar.repeatweekly')
      }, {
        value: 2,
        label: this.$t('calendar.repeatmonthly')
      }, {
        value: 3,
        label: this.$t('calendar.repeatyear')
      }, {
        value: 4,
        label: this.$t('calendar.custom')
      }],
      repeatData: {},
      repeatDialogData: {},
      width: '520px',
      pickerOptions: {
        firstDayOfWeek: 1
      },
      loading: false
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    formData: {
      handler: function handler(nVal) {
        if (this.formData.edit) {
          this.rules.content = this.formData.data.content;
          this.rules.marks = this.formData.data.mark;
          this.rules.time = this.formData.data.remind_day + ' ' + this.formData.data.remind_time;
          this.rules.repeat = this.formData.data.repeat;
        } else {
          this.rules.time = this.formData.date;
        }
      },
      deep: true
    },
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.options = [{
        value: -1,
        label: this.$t('calendar.norepetition')
      }, {
        value: 0,
        label: this.$t('calendar.repeatbyday')
      }, {
        value: 1,
        label: this.$t('calendar.repeatweekly')
      }, {
        value: 2,
        label: this.$t('calendar.repeatmonthly')
      }, {
        value: 3,
        label: this.$t('calendar.repeatyear')
      }, {
        value: 4,
        label: this.$t('calendar.custom')
      }];
    },
    handleClose: function handleClose() {
      this.drawer = false;
      // 取消编辑
      if (this.formData.edit) {
        this.rules.content = '';
        this.rules.marks = '';
        this.rules.time = '';
        this.rules.repeat = '';
      }
    },
    openBox: function openBox() {
      this.drawer = true;
    },
    handleRepeat: function handleRepeat(e) {},
    rulesOptionChange: function rulesOptionChange(e) {
      if (e === 4) {
        this.repeatData = {
          title: this.$t('calendar.customrepeat'),
          width: this.width
        };
        if (this.formData.edit) {
          this.repeatData.data = this.formData.data;
          this.repeatData.edit = true;
        } else {
          this.repeatData.edit = false;
        }
        this.$refs.repeatDialog.dialogVisible = true;
      }
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var data = {};
          if (_this.formData.data.types === 'client_track') {
            data = {
              eid: _this.formData.data.id,
              types: 0,
              time: _this.$moment(_this.rules.time).format('YYYY-MM-DD HH:mm:ss'),
              content: _this.rules.content
            };
          } else {
            data = {
              content: _this.rules.content,
              mark: _this.rules.marks,
              remind: _this.$moment(_this.rules.time).format('YYYY-MM-DD HH:mm:ss'),
              repeat: _this.rules.repeat,
              types: _this.formData.data.types
            };
            if (_this.rules.repeat === 4) {
              data.period = _this.repeatDialogData.repeat;
              data.rate = _this.repeatDialogData.rate;
              if (_this.repeatDialogData.repeat === 1) {
                data.days = _this.repeatDialogData.weekDays;
              } else if (_this.repeatDialogData.repeat === 2) {
                data.days = _this.repeatDialogData.monthDays;
              } else {
                data.days = [];
              }
              data.end_time = _this.repeatDialogData.end_time;
            }
          }
          // 编辑待办
          if (_this.formData.edit) {
            _this.getScheduleEdit(_this.formData.data.id, data);
          } else if (_this.formData.edit && _this.formData.data.types === 'client_track') {
            _this.clientFollowEdit(_this.formData.data.id, data);
          } else {
            _this.getScheduleAdd(data);
          }
        }
      });
    },
    repeatReset: function repeatReset() {
      this.$refs.repeatDialog.rules.repeat = 0;
      this.$refs.repeatDialog.rules.rate = 1;
      this.$refs.repeatDialog.rules.end_time = '';
      this.$refs.repeatDialog.rules.weekDays = [];
      this.$refs.repeatDialog.rules.monthDays = [];
      this.$refs.repeatDialog.rules.time = '';
    },
    // 添加待办
    getScheduleAdd: function getScheduleAdd(data) {
      var _this2 = this;
      this.loading = true;
      dealtScheduleAddApi(data).then(function (res) {
        _this2.rules.time = '';
        _this2.rules.marks = '';
        _this2.rules.content = '';
        _this2.rules.repeat = -1;
        _this2.drawer = false;
        _this2.repeatReset();
        _this2.$emit('isOk', 1);
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
      });
    },
    // 编辑待办
    getScheduleEdit: function getScheduleEdit(id, data) {
      var _this3 = this;
      this.loading = true;
      dealtScheduleEditApi(id, data).then(function (res) {
        _this3.rules.time = '';
        _this3.rules.marks = '';
        _this3.rules.content = '';
        _this3.rules.repeat = -1;
        _this3.drawer = false;
        _this3.$emit('isOk', 2);
        _this3.loading = false;
        _this3.repeatReset();
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    handleRepeatData: function handleRepeatData(data) {
      if (data.close) {} else {
        this.repeatDialogData = data;
      }
    },
    // 跟进记录--修改客户提醒
    clientFollowEdit: function clientFollowEdit(id, data) {
      var _this4 = this;
      this.loading = true;
      clientFollowEditApi(id, data).then(function (res) {
        _this4.rules.time = '';
        _this4.rules.marks = '';
        _this4.rules.content = '';
        _this4.rules.repeat = -1;
        _this4.drawer = false;
        _this4.$emit('isOk', 2);
        _this4.loading = false;
      }).catch(function (error) {
        _this4.loading = false;
      });
    }
  }
};